import React from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

export interface GenreTag {
    genre: string;
    onClickGenre?: (genre: string) => void;
    active?: boolean;
    tagStyle?: React.CSSProperties;
    tagtextStyle?: React.CSSProperties;
    additionalData?: string | number;
    groupLayout?: boolean;
}

const EsGenreTag: React.FC<GenreTag> = ({
    genre,
    onClickGenre,
    active,
    tagStyle,
    tagtextStyle,
    additionalData,
    groupLayout,
}) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle, active);

    return (
        <Box
            style={{
                ...styles.container,
                ...tagStyle,
                ...(groupLayout &&
                    active && {
                        borderRadius: 9,
                        boxShadow: `0px 0px 2.5px ${theme[themeStyle].gray_sidebar}`,
                        position: 'relative',
                        zIndex: 1,
                    }),
                ...(groupLayout &&
                    !active && {
                        borderRadius: 9,
                        backgroundColor: 'transparent',
                    }),
            }}
            onClick={() => onClickGenre && onClickGenre(genre)}>
            <Typography style={{ ...styles.text, ...tagtextStyle }} sx={{ whiteSpace: 'nowrap' }}>
                {genre}
            </Typography>
            {additionalData && (
                <Typography style={{ ...styles.text, ...tagtextStyle }} sx={{ whiteSpace: 'nowrap' }}>
                    {' ('}
                    {additionalData}
                    {')'}
                </Typography>
            )}
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme, active?: boolean) =>
    StyleSheet.create({
        container: {
            width: 'fit-content',
            cursor: 'pointer',
            height: '32px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 100,
            paddingLeft: 18,
            paddingRight: 18,
            border: 'none',
            backgroundColor: active ? theme[colorScheme].lightWhite : theme[colorScheme].dropdown_black,
        },
        text: {
            fontSize: 16,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            textAlign: 'left',
            color: active ? theme[colorScheme].dropdown_black : theme[colorScheme].form_label,
        },
    });

export { EsGenreTag };
